// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — rack-state-line.styled.classic.js, новая — rack-state-line.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './rack-state-line.styled.classic';
import * as cp from './rack-state-line.styled.cp';

export const Head = isCp ? cp.Head : classic.Head;
export const Line = isCp ? cp.Line : classic.Line;
